<div *ngIf="isloader" class="h-100 w-100 padt-5">
  <mat-progress-bar [mode]="'indeterminate'">
  </mat-progress-bar>
</div>
<div class="h-100 w-100 padt-5 common-text-container" *ngIf="!isloader && !isError">
  <div class="title">{{ widgetData?.title }}</div>
  <div class="d-flex align-items-center justify-content-center">
    <div class="value" [ngStyle]="{'color': attributeColor}" *ngIf="attributeValue; else noContent">
      {{ attributeValue | attributeValueReplace : valueReplaceList }} {{ widgetData?.dataAttributes?.unit }}
    </div>
    <ng-template #noContent>
      <div class="no-data-style">No Data</div>
    </ng-template>
  </div>
</div>
